export default "__VITE_ASSET__zd9EV7Tm__"